var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _ from "lodash";
import streetTypes from "street-types";
const states = [
    {
        name: "Alabama",
        abbreviation: "AL",
    },
    {
        name: "Alaska",
        abbreviation: "AK",
    },
    {
        name: "American Samoa",
        abbreviation: "AS",
    },
    {
        name: "Arizona",
        abbreviation: "AZ",
    },
    {
        name: "Arkansas",
        abbreviation: "AR",
    },
    {
        name: "California",
        abbreviation: "CA",
    },
    {
        name: "Colorado",
        abbreviation: "CO",
    },
    {
        name: "Connecticut",
        abbreviation: "CT",
    },
    {
        name: "Delaware",
        abbreviation: "DE",
    },
    {
        name: "District Of Columbia",
        abbreviation: "DC",
    },
    {
        name: "Federated States Of Micronesia",
        abbreviation: "FM",
    },
    {
        name: "Florida",
        abbreviation: "FL",
    },
    {
        name: "Georgia",
        abbreviation: "GA",
    },
    {
        name: "Guam",
        abbreviation: "GU",
    },
    {
        name: "Hawaii",
        abbreviation: "HI",
    },
    {
        name: "Idaho",
        abbreviation: "ID",
    },
    {
        name: "Illinois",
        abbreviation: "IL",
    },
    {
        name: "Indiana",
        abbreviation: "IN",
    },
    {
        name: "Iowa",
        abbreviation: "IA",
    },
    {
        name: "Kansas",
        abbreviation: "KS",
    },
    {
        name: "Kentucky",
        abbreviation: "KY",
    },
    {
        name: "Louisiana",
        abbreviation: "LA",
    },
    {
        name: "Maine",
        abbreviation: "ME",
    },
    {
        name: "Marshall Islands",
        abbreviation: "MH",
    },
    {
        name: "Maryland",
        abbreviation: "MD",
    },
    {
        name: "Massachusetts",
        abbreviation: "MA",
    },
    {
        name: "Michigan",
        abbreviation: "MI",
    },
    {
        name: "Minnesota",
        abbreviation: "MN",
    },
    {
        name: "Mississippi",
        abbreviation: "MS",
    },
    {
        name: "Missouri",
        abbreviation: "MO",
    },
    {
        name: "Montana",
        abbreviation: "MT",
    },
    {
        name: "Nebraska",
        abbreviation: "NE",
    },
    {
        name: "Nevada",
        abbreviation: "NV",
    },
    {
        name: "New Hampshire",
        abbreviation: "NH",
    },
    {
        name: "New Jersey",
        abbreviation: "NJ",
    },
    {
        name: "New Mexico",
        abbreviation: "NM",
    },
    {
        name: "New York",
        abbreviation: "NY",
    },
    {
        name: "North Carolina",
        abbreviation: "NC",
    },
    {
        name: "North Dakota",
        abbreviation: "ND",
    },
    {
        name: "Northern Mariana Islands",
        abbreviation: "MP",
    },
    {
        name: "Ohio",
        abbreviation: "OH",
    },
    {
        name: "Oklahoma",
        abbreviation: "OK",
    },
    {
        name: "Oregon",
        abbreviation: "OR",
    },
    {
        name: "Palau",
        abbreviation: "PW",
    },
    {
        name: "Pennsylvania",
        abbreviation: "PA",
    },
    {
        name: "Puerto Rico",
        abbreviation: "PR",
    },
    {
        name: "Rhode Island",
        abbreviation: "RI",
    },
    {
        name: "South Carolina",
        abbreviation: "SC",
    },
    {
        name: "South Dakota",
        abbreviation: "SD",
    },
    {
        name: "Tennessee",
        abbreviation: "TN",
    },
    {
        name: "Texas",
        abbreviation: "TX",
    },
    {
        name: "Utah",
        abbreviation: "UT",
    },
    {
        name: "Vermont",
        abbreviation: "VT",
    },
    {
        name: "Virgin Islands",
        abbreviation: "VI",
    },
    {
        name: "Virginia",
        abbreviation: "VA",
    },
    {
        name: "Washington",
        abbreviation: "WA",
    },
    {
        name: "West Virginia",
        abbreviation: "WV",
    },
    {
        name: "Wisconsin",
        abbreviation: "WI",
    },
    {
        name: "Wyoming",
        abbreviation: "WY",
    },
];
export function toFixed(num, precision) {
    if (!num)
        return "0.00";
    return (+(Math.round(+(num + "e" + precision)) + "e" + -precision)).toFixed(precision);
}
export function parseCentsInt(string) {
    return Math.round(parseFloat(string) * 100);
}
export function getSubscriptionCadenceString(subscription) {
    // WILL BE WRONG FOR DECEMBER
    if (!subscription)
        return "none";
    const { cadence, cadenceCount, cartType } = subscription;
    const cadenceStriung = `${cadenceCount}x a ${cadence} ${cartType}`;
    return cadenceStriung;
}
export function getCartItemPrice(cartItem) {
    if (cartItem.manuallyAddedItem)
        return "0.00"; // ! WONT WORK FOR EDITING ORDERS AND ADDING SAME ITEMS
    let sum = parseFloat(cartItem.price);
    const optionCategories = cartItem.optionCategories;
    if (Array.isArray(optionCategories)) {
        for (let i = 0; i < optionCategories.length; i++) {
            const options = optionCategories[i].options;
            if (Array.isArray(options)) {
                for (let j = 0; j < options.length; j++) {
                    const option = options[j];
                    if (option.price === "")
                        continue;
                    if (options[j].selected)
                        sum += parseFloat(options[j].price);
                    if (options[j].quantitySelected)
                        sum += parseFloat(options[j].price) * options[j].quantitySelected;
                }
            }
        }
    }
    const quantity = cartItem.quantity;
    if (Number.isInteger(quantity))
        sum *= quantity;
    return toFixed(sum, 2);
}
export function getCartItemUnitPrice(cartItem) {
    if (cartItem.manuallyAddedItem)
        return "0.00"; // ! WONT WORK FOR EDITING ORDERS AND ADDING SAME ITEMS
    let sum = parseFloat(cartItem.price);
    const optionCategories = cartItem.optionCategories;
    if (Array.isArray(optionCategories)) {
        for (let i = 0; i < optionCategories.length; i++) {
            const options = optionCategories[i].options;
            if (Array.isArray(options)) {
                for (let j = 0; j < options.length; j++) {
                    const option = options[j];
                    if (option.price === "")
                        continue;
                    if (options[j].selected)
                        sum += parseFloat(options[j].price);
                    if (options[j].quantitySelected)
                        sum += parseFloat(options[j].price) * options[j].quantitySelected;
                }
            }
        }
    }
    return toFixed(sum, 2);
}
export function getSubtotal(items) {
    if (!Array.isArray(items))
        return "0.00";
    let sum = 0.0;
    for (let i = 0; i < items.length; i++) {
        sum += parseFloat(getCartItemPrice(items[i]));
    }
    return toFixed(sum, 2);
}
export function getOrderFees(order) {
    // TODO: MAKE SURE THIS IS SAME FEES AS updateTaxFeeRefund in REFUNDS
    const orderFees = [];
    let sum = 0;
    if (typeof order.deliveryFee === "string" &&
        !isNaN(order.deliveryFee) &&
        parseFloat(order.deliveryFee) > 0)
        orderFees.push(order.deliveryFee);
    for (let i = 0; i < orderFees.length; i++) {
        sum += parseFloat(orderFees[i]);
    }
    return sum;
}
export function getOrderTaxes(order) {
    if (order.source === "gift_card_modal")
        return "0.00";
    let sum = parseFloat(getSubtotal(order.cartItems));
    if (!order.giftCard)
        sum -= parseFloat(getOrderDiscount(order));
    sum += getOrderFees(order);
    sum *= parseFloat(order.siteSettings.taxRate);
    return toFixed(sum, 2);
}
export function getOrderTaxesAndHotplateFee(order) {
    return toFixed(parseFloat(getOrderTaxes(order)) +
        (chargeHotplateFee(order)
            ? parseFloat(getOrderHotplateFees(order))
            : 0.0), 2);
}
/**
 * Whether the customer is charged a Hotplate fee, unless
 * includeChef is true, in which case it returns whether
 * *anyone* (customer or chef) is charged a Hotplate fee.
 */
export function chargeHotplateFee(order, includeChef = false) {
    return (order.siteSettings &&
        order.siteSettings.constructor == Object &&
        (!order.siteSettings.chargeHotplateFeeToChef || includeChef) &&
        typeof order.siteSettings.hotplateFee === "string" &&
        order.siteSettings.hotplateFee !== "" &&
        parseFloat(order.siteSettings.hotplateFee) > 0);
}
/**
 * Returns Hotplate fee paid by the customer, unless includeChef is true,
 * in which case it returns the fee paid by the chef *OR* customer.
 */
export function getOrderHotplateFees(order, includeChef = false) {
    if (order.source === "gift_card_modal")
        return "0.00";
    let sum = 0.0;
    if (chargeHotplateFee(order, includeChef)) {
        const hotplateFee = parseFloat(order.siteSettings.hotplateFee);
        sum += parseFloat(getSubtotal(order.cartItems)) * hotplateFee;
    }
    return toFixed(sum, 2);
}
export function getCustomerPaymentProcessingFee(order) {
    const amount = parseFloat(getOrderTotal(order, false));
    return toFixed((amount + 0.3) / (1 - 0.029) - amount, 2);
}
export function getOrderDiscount(order) {
    let discount = "0.00";
    if (order.discountCode) {
        if (order.discountCode.type === "percentage") {
            discount = toFixed(parseFloat(getSubtotal(order.cartItems)) * order.discountCode.amount, 2);
        }
        else if (order.discountCode.type === "flat") {
            discount = toFixed(Math.min(order.discountCode.amount, parseFloat(getSubtotal(order.cartItems))), 2);
        }
    }
    if (order.giftCard) {
        discount = toFixed(Math.min(parseFloat(order.giftCard.balance) + parseFloat(discount), parseFloat(getSubtotal(order.cartItems))), 2);
    }
    return discount;
}
export function isCollabOrder(order) {
    if (Array.isArray(order.cartItems)) {
        return (order.cartItems.filter((item) => {
            return typeof item.collabId === "string" && item.collabId !== "";
        }).length > 0);
    }
    return false;
}
// export function isCollabEvent(event) {
//   let isCollab = false;
//   const menuItems = event.menuItems;
//   if (typeof menuItems === 'object' && menuItems !== null && !Array.isArray(menuItems)) {
//     for (//)
//   }
//   return isCollab;
// }
export function getCollabCartItems(order, collabId) {
    if (Array.isArray(order.cartItems)) {
        return order.cartItems.filter((item) => {
            return (item.collabId === collabId ||
                (!item.collabId && collabId === order.siteSettings.chefId));
        });
    }
    return [];
}
export function getCollabOrder(order, collabId) {
    const newOrder = _.cloneDeep(order);
    if (Array.isArray(newOrder.cartItems)) {
        newOrder.cartItems = newOrder.cartItems.filter((item) => {
            return (item.collabId === collabId ||
                (!item.collabId && collabId === newOrder.siteSettings.chefId));
        });
    }
    let numCollaborators = 0;
    const seenIds = new Set();
    if (Array.isArray(order.cartItems)) {
        for (let i = 0; i < order.cartItems.length; i++) {
            const cartItem = order.cartItems[i];
            seenIds.add(cartItem.collabId ? cartItem.collabId : order.siteSettings.chefId);
        }
        numCollaborators = seenIds.size;
    }
    newOrder.collaborators = [...seenIds];
    if (newOrder.tip && parseFloat(newOrder.tip) && numCollaborators > 0) {
        newOrder.tip = toFixed(parseFloat(newOrder.tip) / numCollaborators, 2);
    }
    if (!seenIds.has(collabId)) {
        newOrder.noFees = true;
        newOrder.tip = toFixed(0, 2);
    }
    return newOrder;
}
export function getOrderTotal(order, includePaymentProcessing = true) {
    let sum = "0.00";
    const subtotal = getSubtotal(order.cartItems);
    const discount = getOrderDiscount(order);
    const hotplateFees = !order.siteSettings.chargeHotplateFeeToChef
        ? getOrderHotplateFees(order)
        : "0.00";
    const taxes = getOrderTaxes(order);
    const fees = getOrderFees(order);
    const tip = order.tip ? order.tip : "0.00";
    const customerPaymentProcessingFee = order.siteSettings.chargeCustomerPaymentProcessing &&
        includePaymentProcessing
        ? getCustomerPaymentProcessingFee(order)
        : "0.00";
    sum = toFixed(parseFloat(sum) + parseFloat(subtotal), 2);
    sum = toFixed(parseFloat(sum) - parseFloat(discount), 2);
    sum = toFixed(parseFloat(sum) + parseFloat(hotplateFees), 2);
    sum = toFixed(parseFloat(sum) + parseFloat(taxes), 2);
    sum = toFixed(parseFloat(sum) + fees, 2);
    sum = toFixed(parseFloat(sum) + parseFloat(tip), 2);
    sum = toFixed(parseFloat(sum) + parseFloat(customerPaymentProcessingFee), 2);
    return sum;
}
export function getOrderRefundTotal(order) {
    if (order.refundTotal)
        return order.refundTotal;
    else
        return toFixed(0, 2);
}
export function nth(d) {
    if (d > 3 && d < 21)
        return "th";
    switch (d % 10) {
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
}
export function getModStringExport(item) {
    return getModString(item);
}
export function getVariationStringExport(item) {
    return getVariationString(item);
}
export function getModString(item) {
    let modString = "";
    if (Array.isArray(item.mods)) {
        for (let j = 0; j < item.mods.length; j++) {
            const mod = item.mods[j];
            if (Array.isArray(mod.options)) {
                for (let k = 0; k < mod.options.length; k++) {
                    const option = mod.options[k];
                    if (option.selected) {
                        if (modString !== "")
                            modString += ", ";
                        modString += option.name;
                    }
                    if (option.quantitySelected) {
                        if (modString !== "")
                            modString += ", ";
                        modString += option.quantitySelected + "x " + option.name;
                    }
                }
            }
        }
    }
    if (item.notes)
        modString += " • " + item.notes;
    return modString;
}
function getVariationString(item) {
    let variationString = "";
    if (Array.isArray(item.variations)) {
        for (let j = 0; j < item.variations.length; j++) {
            const variation = item.variations[j];
            if (Array.isArray(variation.options)) {
                for (let k = 0; k < variation.options.length; k++) {
                    const option = variation.options[k];
                    if (option.selected) {
                        if (variationString !== "")
                            variationString += ", ";
                        variationString += option.name;
                    }
                    if (option.quantitySelected) {
                        if (variationString !== "")
                            variationString += ", ";
                        variationString += option.quantitySelected + "x " + option.name;
                    }
                }
            }
        }
    }
    return variationString;
}
export function getFormattedPosCart(cart) {
    const formattedCart = [];
    for (let i = 0; i < cart.length; i++) {
        if (cart[i].mods)
            cart[i].modsObj = _.cloneDeep(cart[i].mods);
        if (cart[i].variations)
            cart[i].variationsObj = _.cloneDeep(cart[i].variations);
        let seen = false;
        for (let j = 0; j < formattedCart.length; j++) {
            if (cart[i].title === formattedCart[j].title &&
                getModString(cart[i]) === getModString(formattedCart[j]) &&
                getVariationString(cart[i]) === getVariationString(formattedCart[j])) {
                formattedCart[j].quantity += 1;
                seen = true;
                break;
            }
        }
        if (!seen) {
            cart[i].quantity = 1;
            formattedCart.push(_.cloneDeep(cart[i]));
        }
    }
    for (let i = 0; i < formattedCart.length; i++) {
        const item = formattedCart[i];
        formattedCart[i].mods = getModString(item);
        formattedCart[i].variations = getVariationString(item);
    }
    return formattedCart;
}
// PORTAL FUNCTIONS //
export function getOrderRevenue(order) {
    if (order.source && order.source !== "gift_card_modal")
        return "0.00";
    let revenue = "0.00";
    const orderTotal = getOrderTotal(order);
    const refundTotal = order.refundTotal ? order.refundTotal : "0.00";
    const paymentProcessing = getPaymentProcessing(order);
    const hotplateFees = getOrderHotplateFees(order, true);
    const hotplateFeeRefund = order.hotplateFeeRefund
        ? order.hotplateFeeRefund
        : "0.00";
    revenue = toFixed(parseFloat(revenue) + parseFloat(orderTotal), 2);
    revenue = toFixed(parseFloat(revenue) - parseFloat(paymentProcessing), 2);
    revenue = toFixed(parseFloat(revenue) - parseFloat(hotplateFees), 2);
    revenue = toFixed(parseFloat(revenue) - parseFloat(refundTotal), 2);
    revenue = toFixed(parseFloat(revenue) + parseFloat(hotplateFeeRefund), 2);
    return revenue;
}
export function getRizeRevenue(order) {
    const orderTotal = getOrderTotal(order);
    return toFixed(parseFloat(orderTotal), 2);
}
export function getChefTip(order) {
    return toFixed(order.chefTip / 100, 2);
}
export function getPaymentProcessing(order) {
    const orderTotal = getOrderTotal(order);
    let fixedFee = 0.3;
    if (Array.isArray(order.collaborators)) {
        fixedFee = 0.3 / order.collaborators.length;
        if (order.noFees)
            fixedFee = 0;
    }
    return toFixed(parseFloat(orderTotal) * 0.029 + fixedFee, 2);
}
export function getNumberOrdinal(n) {
    const s = ["th", "st", "nd", "rd"];
    let v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}
export function getLocationState(locationDict, shorten = true) {
    if (!locationDict || locationDict.constructor != Object)
        return "";
    let state = locationDict.state;
    // set state to .state in case no abbreviation is found
    for (let i = 0; i < states.length; i++) {
        const stateObj = states[i];
        if (stateObj.name.toUpperCase() === state.toUpperCase()) {
            if (shorten) {
                state = stateObj.abbreviation;
            }
            else {
                state = stateObj.name;
            }
        }
    }
    return state;
}
export function getLocationZip(locationDict) {
    if (!locationDict || locationDict.constructor != Object)
        return "";
    return locationDict.zip;
}
export function getLocationCity(locationDict) {
    if (!locationDict || locationDict.constructor != Object)
        return "";
    return titleCase(locationDict.city);
}
export function getLocationStreetAddress(locationDict) {
    if (!locationDict || locationDict.constructor != Object)
        return "";
    const streetNumber = locationDict.streetNumber;
    let street = locationDict.streetRoute;
    const unit = locationDict.unit || "";
    const streetType = locationDict.streetRoute
        .split(" ")
        .slice(-1)
        .toString()
        .toUpperCase();
    // last item in the streetRoute will always be the location of streetType, if one exists
    for (let i = 0; i < streetTypes.length; i++) {
        const obj = streetTypes[i];
        if (obj.suffix.toUpperCase() === streetType) {
            street = street.split(" ").slice(0, -1); // remove unabbreviated streetType
            street.push(capitalizeFirstLetter(obj.standardAbbr.toLowerCase())); // adding abbreviated streetType from filter
            street = street.join(" "); // converting street back into string
        }
    }
    return `${streetNumber} ${street}${unit !== "" ? ", " + unit : ""}`;
}
export function getAddressString(location, streetAddressOnly = false, cityStateZipOnly = false) {
    if (!location ||
        location.constructor != Object ||
        !location.addressDict ||
        location.addressDict.constructor != Object)
        return "";
    const addressDict = location.addressDict;
    let state = addressDict.state;
    // set state to .state in case no abbreviation is found
    let street = addressDict.streetRoute;
    // set street to .streetRoute in case no abbreviation is found
    const streetType = addressDict.streetRoute
        .split(" ")
        .slice(-1)
        .toString()
        .toUpperCase();
    // last item in the streetRoute will always be the location of streetType, if one exists
    for (let i = 0; i < streetTypes.length; i++) {
        const obj = streetTypes[i];
        if (obj.suffix.toUpperCase() === streetType) {
            street = street.split(" ").slice(0, -1); // remove unabbreviated streetType
            street.push(capitalizeFirstLetter(obj.standardAbbr.toLowerCase())); // adding abbreviated streetType from filter
            street = street.join(" "); // converting street back into string
        }
    }
    for (let i = 0; i < states.length; i++) {
        const obj = states[i];
        if (obj.name.toUpperCase() === addressDict.state.toUpperCase()) {
            state = obj.abbreviation;
        }
    }
    if (streetAddressOnly) {
        return `${addressDict.streetNumber} ${street}${typeof addressDict.unit === "string" && addressDict.unit !== ""
            ? ", " + addressDict.unit
            : ""}`;
    }
    if (cityStateZipOnly) {
        return `${addressDict.city}, ${state} ${addressDict.zip}`;
    }
    if (location.displayFullAddress) {
        return (addressDict.streetNumber +
            " " +
            street +
            ", " +
            (typeof addressDict.unit === "string" && addressDict.unit !== ""
                ? addressDict.unit + ", "
                : "") +
            addressDict.city +
            ", " +
            state);
    }
    else {
        return addressDict.city + ", " + state + " " + addressDict.zip;
    }
}
export function getAbbreviatedTimezone() {
    const timezoneString = new Date()
        .toLocaleTimeString("en-us", { timeZoneName: "short" })
        .split(" ")[2];
    return timezoneString;
}
export function getTimestampWeekYear(timestamp) {
    var date = new Date(timestamp);
    date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
    return date.getFullYear();
}
export function getTimestampWeekNumber(timestamp) {
    const date = new Date(timestamp);
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
    // January 4 is always in week 1.
    const week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return (1 +
        Math.round(((date.getTime() - week1.getTime()) / 86400000 -
            3 +
            ((week1.getDay() + 6) % 7)) /
            7));
}
export function getTimestampDayOfWeek(timestamp, shorten) {
    if (!Number.isInteger(timestamp))
        return "";
    const daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];
    let dayOfWeek = daysOfWeek[new Date(timestamp).getDay()];
    if (shorten)
        dayOfWeek = dayOfWeek.substring(0, 3);
    return dayOfWeek;
}
export function getTimeWindowCardLocationTitle(timeWindow) {
    if (!timeWindow)
        return "";
    const locations = getSortedLocations(timeWindow.locations);
    if (locations.length === 0)
        return "";
    if (locations.length >= 2)
        return locations.length + " locations";
    return locations[0].title;
}
export function getTimeWindowCardIncomplete(timeWindow, recurring) {
    if (!timeWindow)
        return true;
    const locations = getSortedLocations(timeWindow.locations);
    if (locations.length === 0)
        return true;
    if (!Number.isInteger(timeWindow.startTime) &&
        !Number.isInteger(timeWindow.startTime))
        return true;
    if (!recurring && new Date().getTime() > timeWindow.startTime)
        return true;
    return false;
}
export function formatToCurrency(amount, lang = "en-US", currency = "USD") {
    if (amount === null || amount === undefined)
        return "";
    return Intl.NumberFormat(lang, {
        style: "currency",
        currency: currency,
    }).format(amount);
}
export function getTimestampMonth(timestamp, shorten) {
    const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    let month = "";
    const d = new Date(timestamp);
    month = monthNames[d.getMonth()];
    if (shorten)
        month = month.substring(0, 3);
    return month;
}
export function getTimestampDayOfWeekMonthDate(timestamp, shorten) {
    if (!Number.isInteger(timestamp))
        return "";
    const d = new Date(timestamp);
    const dayOfWeek = getTimestampDayOfWeek(timestamp, true);
    const month = getTimestampMonth(timestamp, shorten);
    const date = d.getDate() + nth(d.getDate());
    return dayOfWeek + ", " + month + " " + date;
}
export function getTimestampMonthDate(timestamp, shorten = false) {
    if (!Number.isInteger(timestamp))
        return "";
    const d = new Date(timestamp);
    const month = getTimestampMonth(timestamp, shorten);
    const date = d.getDate() + nth(d.getDate());
    return month + " " + date;
}
export function getTimestampMonthDateYear(timestamp, shorten = false) {
    if (!Number.isInteger(timestamp))
        return "";
    const d = new Date(timestamp);
    const month = getTimestampMonth(timestamp, shorten);
    const date = d.getDate() + nth(d.getDate()) + " " + d.getFullYear();
    return month + " " + date;
}
export function getTimestampHoursMinutesAMPM(timestamp) {
    if (!Number.isInteger(timestamp))
        return "";
    const d = new Date(timestamp);
    let hours = d.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    if (hours === 0)
        hours = 12;
    const minutes = (d.getMinutes() < 10 ? "0" : "") + d.getMinutes();
    return hours + ":" + minutes + ampm;
}
export function priceInputIsValid(price) {
    if (!/^\d*\.?\d*$/.test(price) && price !== "")
        return false;
    const decimalIndex = price.indexOf(".");
    if (decimalIndex !== -1 && price.length - decimalIndex > 3)
        return false;
    return true;
}
export function getDetailedEventStatus(event) {
    const thirtyMinutesInSeconds = 60 * 30;
    const generalEventStatus = getEventStatus(event); // live, scheduled, complete, draft
    if (generalEventStatus === "draft" ||
        generalEventStatus === "complete" ||
        generalEventStatus === "live")
        return generalEventStatus;
    if (generalEventStatus === "scheduled") {
        if (getTimeUntilGoLive(event.goLiveTime) <= thirtyMinutesInSeconds) {
            return "opening";
        }
    }
    return "scheduled";
    // also a possibility for us to return a status such as "closing" if we want to add new functionality like a countdown to event close
}
export function getEventStatus(event) {
    // TODO: USED IN CLOUD FUNCTIONS - MAKE THIS SHARED REPO AND COPY OVER WHEN NEEDED
    // live, scheduled, complete, draft
    if (!event)
        return "draft";
    const currTime = new Date().getTime();
    if (event.draft)
        return "draft";
    if (currTime < event.goLiveTime)
        return "scheduled";
    if (event.recurring)
        return "live";
    const orderCutoffType = event.orderCutoffType;
    if (isEventOnDemandActive(event))
        return "live";
    const timeWindows = getSortedTimeWindows(event.timeWindows);
    let lastTime = 0;
    if (timeWindows.length > 0) {
        lastTime = timeWindows.sort((a, b) => {
            return a.endTime - b.endTime;
        })[timeWindows.length - 1].endTime;
    }
    if (event.onDemandEnabled && lastTime > currTime)
        return "live";
    if (orderCutoffType === "Never" || orderCutoffType === "Hours Before") {
        if (lastTime !== 0) {
            if (lastTime -
                (orderCutoffType === "Hours Before"
                    ? event.orderCutoffHoursBefore * 1000 * 60 * 60
                    : 0) <
                currTime)
                return "complete";
            return "live";
        }
    }
    else if (orderCutoffType === "Specific Time") {
        if (currTime < event.orderCutoffTime)
            return "live";
        return "complete";
    }
    return "draft";
}
export function getSortedMenuItems(menuItems) {
    if (!(menuItems instanceof Object))
        return [];
    const sortedMenuItems = [];
    Object.keys(menuItems).forEach((key) => {
        sortedMenuItems.push(menuItems[key]);
    });
    return sortedMenuItems.sort((a, b) => {
        return a.title.localeCompare(b.title);
    });
}
export function getSortedLocations(locations) {
    if (!(locations instanceof Object))
        return [];
    const sortedLocations = [];
    Object.keys(locations).forEach((key) => {
        sortedLocations.push(locations[key]);
    });
    return sortedLocations.sort((a, b) => {
        return a.title.localeCompare(b.title);
    });
}
export function getSortedLocationsEvent({ event, includePickup, includeDelivery, }) {
    if (!(event instanceof Object) || !(event.timeWindows instanceof Object))
        return [];
    const sortedLocations = [];
    Object.keys(event.timeWindows).forEach((timeWindowId) => {
        const timeWindow = event.timeWindows[timeWindowId];
        if ((includePickup && !timeWindow.isDelivery) ||
            (includeDelivery && timeWindow.isDelivery)) {
            const nextLocations = getSortedLocations(timeWindow.locations);
            for (let i = 0; i < nextLocations.length; i++) {
                const nextLocation = nextLocations[i];
                if (sortedLocations.findIndex((location) => location.id === nextLocation.id) === -1) {
                    sortedLocations.push(_.cloneDeep(nextLocation));
                }
            }
        }
    });
    return sortedLocations.sort((a, b) => {
        return a.title.localeCompare(b.title);
    });
}
export function getSortedTimeWindows(timeWindows) {
    // TODO: USED IN CLOUD FUNCTIONS - MAKE THIS SHARED REPO AND COPY OVER WHEN NEEDED
    if (!timeWindows || timeWindows.constructor != Object)
        return [];
    const sortedTimeWindows = [];
    Object.keys(timeWindows).forEach((key) => {
        sortedTimeWindows.push(timeWindows[key]);
    });
    return sortedTimeWindows.sort((a, b) => {
        if (a.startTime === null)
            return -1;
        if (b.startTime === null)
            return 1;
        return a.startTime - b.startTime;
    });
}
export function isMenuEmpty(event) {
    if (!event ||
        event.constructor != Object ||
        !event.menu ||
        !Array.isArray(event.menu.sections) ||
        event.menu.sections.length === 0 ||
        (event.menu.sections.length === 1 &&
            (!Array.isArray(event.menu.sections[0].menuItems) ||
                event.menu.sections[0].menuItems.length === 0))) {
        return true;
    }
    return false;
}
export function getCustomButtonColorsFromChef(chefStyles, variant) {
    let customButtonColors = {
        backgroundColor: chefStyles.primaryColor.toString(),
        backgroundColorHover: chefStyles.primaryColorHover.toString(),
        backgroundColorActive: chefStyles.primaryColorActive.toString(),
        backgroundColorDisabled: chefStyles.primaryColorLight.toString(),
        color: chefStyles.textColor.toString(),
    };
    if (variant === "light") {
        customButtonColors = {
            backgroundColor: chefStyles.primaryColorLight.toString(),
            backgroundColorHover: chefStyles.primaryColorLight.toString(),
            backgroundColorActive: chefStyles.primaryColorLight.toString(),
            backgroundColorDisabled: chefStyles.primaryColorLight.toString(),
            color: chefStyles.primaryColorDark.toString(),
        };
    }
    return customButtonColors;
}
export function getCountdownTimeArray(timeUntilGoLive) {
    let days = Math.floor(timeUntilGoLive / (3600 * 24));
    if (days < 10)
        days = "0" + days;
    let hours = Math.floor((timeUntilGoLive % (3600 * 24)) / 3600);
    if (hours < 10)
        hours = "0" + hours;
    let minutes = Math.floor((timeUntilGoLive % 3600) / 60);
    if (minutes < 10)
        minutes = "0" + minutes;
    let seconds = Math.floor(timeUntilGoLive % 60);
    if (seconds < 10)
        seconds = "0" + seconds;
    return [
        days.toString(),
        hours.toString(),
        minutes.toString(),
        seconds.toString(),
    ];
}
export function getTimeUntilGoLive(goLiveTime) {
    // returns seconds until live
    return Math.ceil(Math.max(0, goLiveTime - new Date().getTime()) / 1000);
    // WARNING: See comment in the React component this is used in before changing
    // the Math.ceil to be Math.floor or Math.round.
}
export function getSortedTimeSlots({ event, locationId, includePickup, includeDelivery, customerZip, }) {
    var _a;
    const timeWindows = getSortedTimeWindows(event.timeWindows);
    const currentTimestamp = new Date().getTime();
    const orderCutoffType = event.orderCutoffType;
    const timeSlots = [];
    let timeSlotIncrement = -1;
    if (event.timeSlotCadence === "5 minutes")
        timeSlotIncrement = 1000 * 60 * 5;
    else if (event.timeSlotCadence === "15 minutes")
        timeSlotIncrement = 1000 * 60 * 15;
    else if (event.timeSlotCadence === "30 minutes")
        timeSlotIncrement = 1000 * 60 * 30;
    else if (event.timeSlotCadence === "60 minutes")
        timeSlotIncrement = 1000 * 60 * 60;
    function getTimeSlotDisabledByCutoff(endTime) {
        if (orderCutoffType === "Never") {
            if (currentTimestamp > endTime)
                return true;
        }
        else if (orderCutoffType === "Hours Before") {
            const hoursCutoff = Number.isInteger(event.orderCutoffHoursBefore)
                ? event.orderCutoffHoursBefore
                : 1;
            if (currentTimestamp + hoursCutoff * 60 * 60 * 1000 > endTime)
                return true;
        }
        else if (orderCutoffType === "Specific Time") {
            if (currentTimestamp > event.orderCutoffTime)
                return true;
        }
        return false;
    }
    for (let i = 0; i < timeWindows.length; i++) {
        const currTimeWindow = timeWindows[i];
        if (typeof locationId === "string" &&
            !(locationId in currTimeWindow.locations))
            continue;
        if (currTimeWindow.isDelivery && !includeDelivery)
            continue;
        if (includeDelivery &&
            customerZip !== "all" &&
            !((_a = event.deliverySettings) === null || _a === void 0 ? void 0 : _a.bypassCheck)) {
            if (!currTimeWindow.servicableZipcodes ||
                currTimeWindow.servicableZipcodes.constructor != Object)
                continue;
            if (!(customerZip in currTimeWindow.servicableZipcodes))
                continue;
        }
        if (!currTimeWindow.isDelivery && !includePickup)
            continue;
        const recurringCount = event.recurring ? event.recurringCount : 1;
        let startTime = currTimeWindow.startTime;
        let endTime = currTimeWindow.endTime;
        if (event.recurring) {
            while (getTimeSlotDisabledByCutoff(startTime)) {
                startTime += 1000 * 60 * 60 * 24 * 7;
                endTime += 1000 * 60 * 60 * 24 * 7;
            }
        }
        for (let j = 0; j < recurringCount; j++) {
            if (timeSlotIncrement === -1) {
                timeSlots.push({
                    disabled: getTimeSlotDisabledByCutoff(endTime),
                    startTime: startTime,
                    endTime: endTime,
                    range: true,
                    isDelivery: currTimeWindow.isDelivery,
                    servicableZipcodes: currTimeWindow.servicableZipcodes,
                    timeZone: currTimeWindow.locations[Object.keys(currTimeWindow.locations)[0]]
                        .timeZone,
                });
            }
            else {
                let timeSlotTime = startTime;
                while (timeSlotTime <= endTime) {
                    timeSlots.push({
                        disabled: getTimeSlotDisabledByCutoff(timeSlotTime),
                        startTime: timeSlotTime,
                        endTime: timeSlotTime,
                        range: false,
                        isDelivery: currTimeWindow.isDelivery,
                        servicableZipcodes: currTimeWindow.servicableZipcodes,
                        timeZone: currTimeWindow.locations[Object.keys(currTimeWindow.locations)[0]]
                            .timeZone,
                    });
                    timeSlotTime += timeSlotIncrement;
                }
            }
            startTime += 1000 * 60 * 60 * 24 * 7;
            endTime += 1000 * 60 * 60 * 24 * 7;
        }
    }
    return timeSlots;
}
export function getMenuItemTimeSlotOptions({ event, menuItem, includePickup, includeDelivery, customerZip, }) {
    // return [{
    //   readableDate: getTimestampDayOfWeekMonthDate(),
    //   timeSlots: [{
    //     disabled: true,
    //     startTime: 123456789, // unixTimestamp ms
    //     endTime: 123456789, // unixTimestamp ms
    //     range: true,
    //     inventoryAvailable: 0,
    //   }],
    //
    // }];
    if (!menuItem ||
        menuItem.constructor != Object ||
        !event ||
        event.constructor != Object)
        return [];
    const timeSlots = getSortedTimeSlots({
        event,
        includePickup,
        includeDelivery,
        customerZip,
    });
    const timeSlotOptionsObj = {};
    for (let i = 0; i < timeSlots.length; i++) {
        const timeSlot = timeSlots[i];
        const readableDate = getTimestampDayOfWeekMonthDate(timeSlot.startTime);
        if (!(readableDate in timeSlotOptionsObj))
            timeSlotOptionsObj[readableDate] = [];
        timeSlotOptionsObj[readableDate].push(timeSlot);
    }
    const timeSlotOptions = [];
    Object.keys(timeSlotOptionsObj).forEach((readableDate) => {
        timeSlotOptionsObj[readableDate].sort((timeSlotA, timeSlotB) => {
            return timeSlotA.startTime - timeSlotB.endTime;
        });
        timeSlotOptions.push({
            readableDate: readableDate,
            timeSlots: timeSlotOptionsObj[readableDate],
        });
    });
    timeSlotOptions.sort((timeSlotOptionA, timeSlotOptionB) => {
        return (timeSlotOptionA.timeSlots[0].startTime -
            timeSlotOptionB.timeSlots[0].startTime);
    });
    const menuItemDatesCount = {};
    const menuItemTimeSlotsCount = {};
    if (menuItem.maxPerRangeType === "timeSlot") {
        for (let j = 0; j < timeSlotOptions.length; j++) {
            const timeSlots = timeSlotOptions[j].timeSlots;
            for (let k = 0; k < timeSlots.length; k++) {
                const timeSlot = timeSlots[k];
                const disabledKey = getDisabledKeyTimeSlot(timeSlot);
                if (!(disabledKey in menuItemTimeSlotsCount))
                    menuItemTimeSlotsCount[disabledKey] = 0;
                menuItemTimeSlotsCount[disabledKey] += getTimeSlotCount(menuItem, event.reservations, timeSlot, "");
            }
        }
    }
    if (menuItem.maxPerRangeType === "date") {
        const reservedTimeSlots = getMenuItemReservedTimeSlots(menuItem, event.reservations);
        Object.keys(reservedTimeSlots).forEach((cartId) => {
            const reservedTimeSlot = reservedTimeSlots[cartId];
            const dateKey = getTimestampDayOfWeekMonthDate(reservedTimeSlot.timeSlot.startTime);
            if (!(dateKey in menuItemDatesCount))
                menuItemDatesCount[dateKey] = 0;
            menuItemDatesCount[dateKey] += reservedTimeSlot.quantity;
        });
    }
    for (let j = 0; j < timeSlotOptions.length; j++) {
        const timeSlots = timeSlotOptions[j].timeSlots;
        for (let k = 0; k < timeSlots.length; k++) {
            const timeSlot = timeSlots[k];
            if (menuItem.maxPerRangeType === "date" &&
                Number.isInteger(menuItem.maxPerDay)) {
                const key = getTimestampDayOfWeekMonthDate(timeSlot.startTime);
                if (!(key in menuItemDatesCount))
                    menuItemDatesCount[key] = 0;
                timeSlot.inventoryAvailable = Math.max(menuItem.maxPerDay - menuItemDatesCount[key]);
            }
            else if (menuItem.maxPerRangeType === "timeSlot" &&
                Number.isInteger(menuItem.maxPerTimeSlot)) {
                const key = getDisabledKeyTimeSlot(timeSlot);
                if (!(key in menuItemTimeSlotsCount))
                    menuItemTimeSlotsCount[key] = 0;
                timeSlot.inventoryAvailable = Math.max(0, menuItem.maxPerTimeSlot - menuItemTimeSlotsCount[key]);
            }
            timeSlot.disabled |= timeSlot.inventoryAvailable <= 0;
            timeSlot.disabled = timeSlot.disabled === 1;
        }
    }
    return timeSlotOptions;
}
function getDisabledKeyTimeSlot(timeSlot) {
    return timeSlot.startTime + ":" + timeSlot.endTime;
}
function getMenuItemReservedTimeSlots(menuItem, reservations) {
    const reservationId = menuItem.volumeRestrictionId
        ? menuItem.volumeRestrictionId
        : menuItem.id;
    let localReservations = reservations ? reservations : {};
    if (!("timeSlots" in localReservations))
        localReservations["timeSlots"] = {};
    if (!(reservationId in localReservations["timeSlots"]))
        localReservations["timeSlots"][reservationId] = {};
    return localReservations["timeSlots"][reservationId];
}
function getTimeSlotCount(menuItem, reservations, timeSlot, customerCartId) {
    const timeSlotKey = getDisabledKeyTimeSlot(timeSlot);
    let count = 0;
    const reservedTimeSlots = getMenuItemReservedTimeSlots(menuItem, reservations);
    if (!reservedTimeSlots)
        return 0;
    Object.keys(reservedTimeSlots).forEach((cartId) => {
        if (cartId !== customerCartId) {
            const reservedTimeSlot = reservedTimeSlots[cartId];
            const reservedTimeSlotKey = getDisabledKeyTimeSlot(reservedTimeSlot.timeSlot);
            if (timeSlotKey === reservedTimeSlotKey) {
                count += reservedTimeSlot.quantity;
            }
        }
    });
    return count;
}
export function getSortedEventTimeSlotOptions({ event, menuItems, locationId, customerCartId, includePickup, includeDelivery, customerZip, }) {
    // return [{
    //   readableDate: getTimestampDayOfWeekMonthDate(),
    //   timeSlots: [{
    //     disabled: true,
    //     startTime: 123456789, // unixTimestamp ms
    //     endTime: 123456789, // unixTimestamp ms
    //     range: true,
    //     ordersAvailable: 0,
    //   }],
    // }];
    const timeSlots = getSortedTimeSlots({
        event,
        locationId,
        includePickup,
        includeDelivery,
        customerZip,
    });
    const timeSlotOptionsObj = {};
    for (let i = 0; i < timeSlots.length; i++) {
        const timeSlot = timeSlots[i];
        const readableDate = getTimestampDayOfWeekMonthDate(timeSlot.startTime, true);
        if (!(readableDate in timeSlotOptionsObj))
            timeSlotOptionsObj[readableDate] = [];
        timeSlotOptionsObj[readableDate].push(timeSlot);
    }
    const timeSlotOptions = [];
    Object.keys(timeSlotOptionsObj).forEach((readableDate) => {
        timeSlotOptionsObj[readableDate].sort((timeSlotA, timeSlotB) => {
            return timeSlotA.startTime - timeSlotB.endTime;
        });
        timeSlotOptions.push({
            readableDate: readableDate,
            timeSlots: timeSlotOptionsObj[readableDate],
        });
    });
    timeSlotOptions.sort((timeSlotOptionA, timeSlotOptionB) => {
        return (timeSlotOptionA.timeSlots[0].startTime -
            timeSlotOptionB.timeSlots[0].startTime);
    });
    const disabledTimeSlots = new Set();
    const disabledTimeSlotsCount = {};
    if (!isMenuEmpty(event) &&
        Number.isInteger(event.menu.maxOrdersPerTimeSlot)) {
        const maxOrdersPerTimeSlot = event.menu.maxOrdersPerTimeSlot;
        const orders = event.reservations ? event.reservations.orders : {};
        if (orders && orders.constructor == Object) {
            Object.keys(orders).forEach((cartId) => {
                if (cartId !== customerCartId) {
                    const disabledTimeSlotsKey = getDisabledKeyTimeSlot(orders[cartId].timeSlot);
                    if (!(disabledTimeSlotsKey in disabledTimeSlotsCount))
                        disabledTimeSlotsCount[disabledTimeSlotsKey] = 0;
                    disabledTimeSlotsCount[disabledTimeSlotsKey] += 1;
                    if (disabledTimeSlotsCount[disabledTimeSlotsKey] >= maxOrdersPerTimeSlot) {
                        disabledTimeSlots.add(disabledTimeSlotsKey);
                    }
                }
            });
        }
        for (let i = 0; i < timeSlotOptions.length; i++) {
            const timeSlots = timeSlotOptions[i].timeSlots;
            for (let j = 0; j < timeSlots.length; j++) {
                const timeSlot = timeSlots[j];
                const disabledTimeSlotKey = getDisabledKeyTimeSlot(timeSlot);
                if (!(disabledTimeSlotKey in disabledTimeSlotsCount))
                    disabledTimeSlotsCount[disabledTimeSlotKey] = 0;
                timeSlot.ordersAvailable =
                    maxOrdersPerTimeSlot - disabledTimeSlotsCount[disabledTimeSlotKey];
                timeSlot.disabled |= disabledTimeSlots.has(disabledTimeSlotKey);
                timeSlot.disabled = timeSlot.disabled === 1;
            }
        }
    }
    if (Array.isArray(menuItems)) {
        const menuItemIdCount = {};
        for (let i = 0; i < menuItems.length; i++) {
            const menuItemId = menuItems[i].id;
            const volumeRestrictionId = menuItems[i].volumeRestrictionId;
            if (typeof volumeRestrictionId === "string" &&
                volumeRestrictionId !== "") {
                if (!(volumeRestrictionId in menuItemIdCount))
                    menuItemIdCount[volumeRestrictionId] = 0;
                menuItemIdCount[volumeRestrictionId] += menuItems[i].quantity || 1;
            }
            else {
                if (!(menuItemId in menuItemIdCount))
                    menuItemIdCount[menuItemId] = 0;
                menuItemIdCount[menuItemId] += menuItems[i].quantity || 1;
            }
        }
        for (let i = 0; i < menuItems.length; i++) {
            const menuItem = menuItems[i];
            if (!event ||
                event.constructor !== Object ||
                !event.menuItems ||
                event.menuItems.constructor !== Object ||
                !(menuItem.id in event.menuItems))
                continue;
            const eventMenuItem = event.menuItems[menuItem.id];
            if (!menuItem ||
                menuItem.constructor != Object ||
                !event ||
                event.constructor != Object)
                continue;
            const disabledMenuItemDates = new Set();
            const disabledMenuItemDatesCount = {};
            const disabledMenuItemTimeSlots = new Set();
            const disabledMenuItemTimeSlotsCount = {};
            if (eventMenuItem.maxPerRangeType === "timeSlot" &&
                Number.isInteger(eventMenuItem.maxPerTimeSlot)) {
                for (let j = 0; j < timeSlotOptions.length; j++) {
                    const timeSlots = timeSlotOptions[j].timeSlots;
                    for (let k = 0; k < timeSlots.length; k++) {
                        const timeSlot = timeSlots[k];
                        const disabledKey = getDisabledKeyTimeSlot(timeSlot);
                        let itemId = menuItem.id;
                        if (typeof menuItem.volumeRestrictionId === "string" &&
                            menuItem.volumeRestrictionId !== "")
                            itemId = menuItem.volumeRestrictionId;
                        if (!(disabledKey in disabledMenuItemTimeSlotsCount))
                            disabledMenuItemTimeSlotsCount[disabledKey] =
                                menuItemIdCount[itemId];
                        disabledMenuItemTimeSlotsCount[disabledKey] += getTimeSlotCount(eventMenuItem, event.reservations, timeSlot, customerCartId);
                        if (disabledMenuItemTimeSlotsCount[disabledKey] >
                            eventMenuItem.maxPerTimeSlot) {
                            disabledMenuItemTimeSlots.add(disabledKey);
                        }
                    }
                }
            }
            if (eventMenuItem.maxPerRangeType === "date" &&
                Number.isInteger(eventMenuItem.maxPerDay)) {
                const reservedTimeSlots = getMenuItemReservedTimeSlots(eventMenuItem, event.reservations);
                Object.keys(reservedTimeSlots).forEach((cartId) => {
                    if (cartId !== customerCartId) {
                        const reservedTimeSlot = reservedTimeSlots[cartId];
                        const disabledKey = getTimestampDayOfWeekMonthDate(reservedTimeSlot.timeSlot.startTime, true);
                        let itemId = menuItem.id;
                        if (typeof menuItem.volumeRestrictionId === "string" &&
                            menuItem.volumeRestrictionId !== "")
                            itemId = menuItem.volumeRestrictionId;
                        if (!(disabledKey in disabledMenuItemDatesCount)) {
                            disabledMenuItemDatesCount[disabledKey] = menuItemIdCount[itemId];
                        }
                        disabledMenuItemDatesCount[disabledKey] +=
                            reservedTimeSlot.quantity;
                        if (disabledMenuItemDatesCount[disabledKey] > eventMenuItem.maxPerDay) {
                            disabledMenuItemDates.add(disabledKey);
                        }
                    }
                });
            }
            for (let j = 0; j < timeSlotOptions.length; j++) {
                const timeSlots = timeSlotOptions[j].timeSlots;
                for (let k = 0; k < timeSlots.length; k++) {
                    const timeSlot = timeSlots[k];
                    timeSlot.disabled |=
                        disabledMenuItemDates.has(getTimestampDayOfWeekMonthDate(timeSlot.startTime, true)) ||
                            disabledMenuItemTimeSlots.has(getDisabledKeyTimeSlot(timeSlot));
                    timeSlot.disabled = timeSlot.disabled === 1;
                    timeSlot.hidden = new Date().getTime() > timeSlot.endTime;
                }
            }
        }
    }
    return timeSlotOptions;
}
export function getReadableTimeSlot(timeSlot) {
    if (!timeSlot ||
        timeSlot.constructor != Object ||
        !Number.isInteger(timeSlot.startTime) ||
        !Number.isInteger(timeSlot.endTime))
        return "";
    return timeSlot.range
        ? new Intl.DateTimeFormat("en-US", {
            hour12: true,
            hour: "numeric",
            minute: "numeric",
            timeZone: timeSlot.timeZone,
            timeZoneName: "short",
        }).formatRange(new Date(timeSlot.startTime), new Date(timeSlot.endTime))
        : new Intl.DateTimeFormat("en-US", {
            hour12: true,
            hour: "numeric",
            minute: "numeric",
            timeZone: timeSlot.timeZone,
            timeZoneName: "short",
        }).format(new Date(timeSlot.startTime));
}
export function getReadableTimeWindow(timeWindow) {
    const timeZone = timeWindow.locations[Object.keys(timeWindow.locations)[0]].timeZone;
    return new Intl.DateTimeFormat("en-US", {
        weekday: "short",
        hour12: true,
        hour: "numeric",
        minute: "numeric",
        timeZone: timeZone,
        timeZoneName: "short",
    }).formatRange(new Date(timeWindow.startTime), new Date(timeWindow.endTime));
}
export function getOrderType(order) {
    const orderType = order.cartType;
    if (order.timeSlot.onDemand)
        return "walk_up";
    return orderType;
}
export function getReadableOrderType(order) {
    const type = getOrderType(order);
    if (type === "walk_up")
        return "Walkup";
    if (type === "delivery")
        return "Delivery";
    if (type === "pickup")
        return "Pickup";
    if (type === "shipping")
        return "Shipping";
    if (type === "catering")
        return "Catering";
    if (type === "wholesale")
        return "Wholesale";
    return "";
}
export function getMenuItemOptionCategoryByType(optionCategories, categoryType) {
    if (!Array.isArray(optionCategories))
        return [];
    return optionCategories.filter((optionCategory) => {
        return optionCategory.categoryType === categoryType;
    });
}
export function getMenuItemOptionsString(menuItem, categoryType) {
    const variationOptionCategories = _.cloneDeep(getMenuItemOptionCategoryByType(menuItem.optionCategories, "variation"));
    const modificationOptionCategories = _.cloneDeep(getMenuItemOptionCategoryByType(menuItem.optionCategories, "modification"));
    let optionCategoriesToStringify = [];
    if (categoryType !== "modification") {
        optionCategoriesToStringify = optionCategoriesToStringify.concat(variationOptionCategories);
    }
    if (categoryType !== "variation") {
        optionCategoriesToStringify = optionCategoriesToStringify.concat(modificationOptionCategories);
    }
    let optionsString = "";
    optionCategoriesToStringify.sort((a, b) => {
        return a.title.localeCompare(b.title);
    });
    for (let i = 0; i < optionCategoriesToStringify.length; i++) {
        const optionCategory = optionCategoriesToStringify[i];
        const options = optionCategory.options;
        if (Array.isArray(options)) {
            options.sort((a, b) => {
                return a.title.localeCompare(b.title);
            });
            for (let j = 0; j < options.length; j++) {
                const option = options[j];
                if (option.selected && !option.deleted) {
                    optionsString += (optionsString === "" ? "" : ", ") + option.title;
                }
                if (option.quantitySelected && !option.deleted) {
                    optionsString +=
                        (optionsString === "" ? "" : ", ") +
                            (option.quantitySelected + "x " + option.title);
                }
            }
        }
    }
    if (categoryType !== "variation" &&
        typeof menuItem.notes === "string" &&
        menuItem.notes !== "") {
        optionsString += (optionsString === "" ? "" : " • ") + menuItem.notes;
    }
    return optionsString;
}
export function getFormattedPhone(num, includeCountryCode = true) {
    if (!(typeof num === "string"))
        return "";
    let formattedNum = "";
    for (let i = includeCountryCode ? 2 : 0; i < num.length; i++) {
        if (num[i] < "0" || num[i] > "9")
            continue;
        formattedNum += num[i];
    }
    const input = formattedNum.replace(/\D/g, "").substring(0, 10); // First ten digits of input only
    const zip = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);
    if (input.length > 6) {
        formattedNum = `(${zip}) ${middle}-${last}`;
    }
    else if (input.length > 3) {
        formattedNum = `(${zip}) ${middle}`;
    }
    else if (input.length > 0) {
        formattedNum = `${zip}`;
    }
    return (includeCountryCode ? "+1 " : "") + formattedNum;
}
export function getUnFormattedPhone(num) {
    if (!(typeof num === "string"))
        return "";
    let formattedNum = "";
    for (let i = num.includes("+1") ? 2 : 0; i < num.length; i++) {
        if (num[i] < "0" || num[i] > "9")
            continue;
        formattedNum += num[i];
    }
    return formattedNum;
}
export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export function getDeviceType() {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
    }
    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return "mobile";
    }
    return "desktop";
}
export function getDateTimeString(timestamp) {
    const monthsArr = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    const date = timestamp ? new Date(timestamp) : new Date();
    const year = date.getFullYear();
    const month = monthsArr[date.getMonth()];
    const day = date.getDate();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    const strTime = hours + ":" + minutes;
    const ampm = date.getHours() >= 12 ? "pm" : "am";
    return month + "-" + day + "-" + year + "-" + strTime + ampm;
}
export function getTimezoneOffset() {
    return new Intl.DateTimeFormat("en-US", { timeZoneName: "short" })
        .format(new Date())
        .split(", ")[1];
}
export function getTimestampMonthYear(timestamp, shorten) {
    const date = new Date(timestamp);
    const monthsArr = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    const fullMonthsArr = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    const year = date.getFullYear();
    const month = shorten
        ? monthsArr[date.getMonth()]
        : fullMonthsArr[date.getMonth()];
    return month + " " + year;
}
export function getNumberedDate(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month < 10)
        month = "0" + month;
    let day = date.getDate();
    if (day < 10)
        day = "0" + day;
    return month + "/" + day + "/" + year;
}
export function isEventOnDemandActive(event) {
    // TODO: USED IN CLOUD FUNCTIONS - MAKE THIS SHARED REPO AND COPY OVER WHEN NEEDED
    let isOnDemand = false;
    if (event && event.constructor == Object) {
        if (event.onDemandEnabled && event.timeWindows) {
            Object.keys(event.timeWindows).forEach((timeWindowId) => {
                const timeWindow = event.timeWindows[timeWindowId];
                if (new Date().getTime() >= timeWindow.startTime &&
                    new Date().getTime() <= timeWindow.endTime) {
                    isOnDemand = true;
                }
            });
        }
    }
    return isOnDemand;
}
export function getTransactionOrderStatus(order) {
    const customerTotal = order.amount / 100;
    const refundTotal = order.refundTotal ? parseFloat(order.refundTotal) : 0.0;
    if (refundTotal <= 0)
        return "received";
    else if (refundTotal >= customerTotal)
        return "fullRefund";
    else
        return "partialRefund";
}
export function getEventOrdersCsvData(orders, isRize, isItemsAsColumns) {
    let hasDelivery = false;
    const csvData = [
        [
            "Order Number",
            "Customer Name",
            "Email",
            "Phone",
            "Date Placed",
            "Time Placed",
            "Date Fulfilled",
            "Time Fulfilled",
            "Export Timezone",
            "Subtotal",
            "Discount Code",
            "Gift Card",
            "Discount Applied To Subtotal",
            "Tax",
            "Delivery Fee",
            "Payment Processing Fee",
            "Hotplate Fee",
            "Tip",
            "Total Revenue",
            "Refund Total",
            "Item Quantity",
            "Item Name",
            "Customer Options",
            "Item Unit Price",
            "Order Type",
            "Fulfillment Address",
            "Delivery Instructions",
        ],
    ];
    const itemTitles = [];
    if (isItemsAsColumns) {
        csvData[0].splice(csvData[0].indexOf("Item Quantity"), 1);
        csvData[0].splice(csvData[0].indexOf("Item Name"), 1);
        csvData[0].splice(csvData[0].indexOf("Customer Options"), 1);
        csvData[0].splice(csvData[0].indexOf("Item Unit Price"), 1);
        for (let i = 0; i < orders.length; i++) {
            const order = orders[i];
            const cartItems = order.cartItems;
            if (Array.isArray(cartItems)) {
                for (let j = 0; j < cartItems.length; j++) {
                    const cartItem = cartItems[j];
                    const itemTitle = cartItem.title;
                    if (itemTitles.includes(itemTitle))
                        continue;
                    itemTitles.push(itemTitle);
                }
            }
        }
        itemTitles.sort((a, b) => a.localeCompare(b));
        for (const itemTitle of itemTitles) {
            csvData[0].splice(csvData[0].indexOf("Order Type"), 0, itemTitle);
        }
    }
    for (let i = 0; i < orders.length; i++) {
        const order = orders[i];
        if (Array.isArray(order.customFields) && !isItemsAsColumns) {
            for (let j = 0; j < order.customFields.length; j++) {
                const title = order.customFields[j].title;
                if (csvData[0].includes(title))
                    continue;
                csvData[0].push(title);
            }
        }
        const cartItems = order.cartItems;
        if (parseFloat(order.deliveryFee) > 0 ||
            order.cartType === "delivery" ||
            (typeof order.deliveryInstructions === "string" &&
                order.deliveryInstructions.length > 0)) {
            hasDelivery = true;
        }
        if (Array.isArray(cartItems)) {
            for (let j = 0; j < cartItems.length; j++) {
                let ppFees = "$" + getPaymentProcessing(order);
                let revenue = "$" + getOrderRevenue(order);
                let deliveryFee = "$0.00";
                if (order.deliveryFee)
                    deliveryFee = "$" + toFixed(parseFloat(order.deliveryFee), 2);
                if (isRize) {
                    ppFees = "$0.00";
                    revenue = "$" + getRizeRevenue(order);
                }
                const orderPhone = order.phone.includes("(")
                    ? order.phone
                    : getFormattedPhone(order.phone);
                // if (j === 0) { // * if statement to configure first row of order in CSV
                const orderRow = [
                    order.orderId,
                    order.fullName,
                    order.email,
                    orderPhone,
                    getNumberedDate(order.orderPlaced),
                    getTimestampHoursMinutesAMPM(order.orderPlaced),
                    getNumberedDate(order.timeSlot.startTime),
                    getReadableTimeSlot(order.timeSlot),
                    getTimezoneOffset(),
                    "$" + getSubtotal(order.cartItems),
                    order.discountCode ? order.discountCode.code : "",
                    order.giftCard ? "Gift Card Used" : "",
                    "$" + getOrderDiscount(order),
                    "$" + getOrderTaxes(order),
                    deliveryFee,
                    ppFees,
                    getOrderHotplateFees(order),
                    "$" + order.tip,
                    revenue,
                    "$" + getOrderRefundTotal(order),
                    cartItems[j].quantity,
                    cartItems[j].title,
                    getMenuItemOptionsString(cartItems[j]),
                    "$" + getCartItemUnitPrice(cartItems[j]),
                    order.cartType,
                    order.cartType === "delivery"
                        ? `${getAddressString({
                            addressDict: order.customerAddressDict,
                            displayFullAddress: true,
                        })} ${order.customerAddressDict.zip}`
                        : `${getAddressString({
                            addressDict: order.location.addressDict,
                            displayFullAddress: true,
                        })} ${order.location.addressDict.zip}`,
                    order.cartType === "delivery"
                        ? order.customerDeliveryInstructions
                        : "",
                ];
                if (isItemsAsColumns) {
                    orderRow.splice(19, 4);
                    for (let z = 0; z < itemTitles.length; z++) {
                        orderRow.splice(csvData[0].indexOf("Order Type") - itemTitles.length, 0, 0);
                    }
                    for (const currCartItem in cartItems) {
                        const currItemTitle = cartItems[currCartItem].title;
                        const currItemQuantity = cartItems[currCartItem].quantity;
                        orderRow[csvData[0].indexOf(currItemTitle)] += currItemQuantity;
                    }
                }
                const orderRowLength = orderRow.length;
                for (let k = orderRowLength; k < csvData[0].length; k++) {
                    orderRow.push("");
                }
                if (Array.isArray(order.customFields) && !isItemsAsColumns) {
                    for (let k = 0; k < order.customFields.length; k++) {
                        const customField = order.customFields[k];
                        orderRow.splice(csvData[0].indexOf(customField.title), 1, customField.value);
                    }
                }
                csvData.push(orderRow);
                if (isItemsAsColumns)
                    break;
                // } else { // * Code to make additional cart items beyond the 1st NOT duplicate the non-item order data on each row
                //   const newRow = new Array(csvData[0].length);
                //   newRow.splice(
                //     csvData[0].indexOf("Item Quantity"),
                //     1,
                //     cartItems[j].quantity
                //   );
                //   newRow.splice(csvData[0].indexOf("Item Name"), 1, cartItems[j].title);
                //   newRow.splice(
                //     csvData[0].indexOf("Customer Options"),
                //     1,
                //     getMenuItemOptionsString(cartItems[j])
                //   );
                //   newRow.splice(
                //     csvData[0].indexOf("Item Unit Price"),
                //     1,
                //     "$" + getCartItemUnitPrice(cartItems[j])
                //   );
                //   csvData.push(newRow);
                // }
            }
        }
    }
    const deliveryFeeIndex = csvData[0].indexOf("Delivery Fee");
    const deliveryInstrIndex = csvData[0].indexOf("Delivery Instructions") - 1;
    for (let i = 0; i < csvData.length; i++) {
        if (!hasDelivery) {
            csvData[i].splice(deliveryFeeIndex, 1);
            csvData[i].splice(deliveryInstrIndex, 1);
        }
    }
    return csvData;
}
export function getSubscriptionOrdersCSVData(orders) {
    const csvData = [
        [
            "Customer Notes",
            "Email",
            "Phone",
            "Full Name",
            "Order Number",
            "Street Address",
            "City",
            "State",
            "Zip",
            "Delivery Instructions",
            "Fulfillment Date",
            "Fulfillment Time",
        ],
    ];
    if (orders) {
        Object.keys(orders).forEach((key) => {
            const order = orders[key];
            if (order.cartType === "delivery") {
                const newRow = new Array(csvData[0].length);
                newRow.splice(csvData[0].indexOf("Customer Notes"), 1, order.customerNotes ? order.customerNotes : "");
                newRow.splice(csvData[0].indexOf("Email"), 1, order.email);
                newRow.splice(csvData[0].indexOf("Full Name"), 1, titleCase(order.fullName));
                newRow.splice(csvData[0].indexOf("Street Address"), 1, getLocationStreetAddress(order.customerAddressDict));
                newRow.splice(csvData[0].indexOf("City"), 1, getLocationCity(order.customerAddressDict));
                newRow.splice(csvData[0].indexOf("State"), 1, getLocationState(order.customerAddressDict));
                newRow.splice(csvData[0].indexOf("Zip"), 1, getLocationZip(order.customerAddressDict));
                newRow.splice(csvData[0].indexOf("Phone"), 1, getFormattedPhone(order.phone));
                newRow.splice(csvData[0].indexOf("Order Number"), 1, order.orderId);
                newRow.splice(csvData[0].indexOf("Delivery Instructions"), 1, order.customerDeliveryInstructions);
                newRow.splice(csvData[0].indexOf("Fulfillment Date"), 1, getNumberedDate(order.timeSlot.startTime));
                newRow.splice(csvData[0].indexOf("Fulfillment Time"), 1, getTimestampHoursMinutesAMPM(order.timeSlot.startTime) +
                    " - " +
                    getTimestampHoursMinutesAMPM(order.timeSlot.endTime));
                for (let j = 0; j < order.cartItems.length; j++) {
                    const cartItem = order.cartItems[j];
                    if (!csvData[0].includes(cartItem.title)) {
                        csvData[0].push(cartItem.title);
                    }
                    newRow.splice(csvData[0].indexOf(cartItem.title), 1, cartItem.quantity);
                }
                csvData.push(newRow);
            }
        });
    }
    return csvData;
}
export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
export function titleCase(str) {
    return str
        .split(" ")
        .map((s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
        .join(" ");
}
export function getDeliveryFee(customerAddressDict, deliverySettings, outOfRadiusPrice = null) {
    if (!deliverySettings ||
        deliverySettings.constructor != Object ||
        !deliverySettings.servicableZipcodes ||
        deliverySettings.servicableZipcodes.constructor != Object)
        return null;
    if (deliverySettings.bypassCheck) {
        return deliverySettings.bypassFee;
    }
    const servicableZipcodes = deliverySettings.servicableZipcodes;
    if (!customerAddressDict || customerAddressDict.constructor != Object)
        return null;
    const customerZip = customerAddressDict.zip;
    if (!(customerZip in servicableZipcodes))
        return outOfRadiusPrice;
    return servicableZipcodes[customerZip];
}
export function getDeliveryAddressError(customerAddressDict, deliverySettings) {
    if (!deliverySettings ||
        deliverySettings.constructor != Object ||
        !deliverySettings.servicableZipcodes ||
        deliverySettings.servicableZipcodes.constructor != Object)
        return "Sorry, you’re out of our range, try a different address";
    if (deliverySettings.bypassCheck) {
        return "";
    }
    const servicableZipcodes = deliverySettings.servicableZipcodes;
    let outOfRangeErrorMessage = deliverySettings.outOfRangeErrorMessage;
    if (typeof outOfRangeErrorMessage !== "string" ||
        outOfRangeErrorMessage === "")
        outOfRangeErrorMessage =
            "Sorry, you’re out of our range, try a different address";
    if (!customerAddressDict || customerAddressDict.constructor != Object)
        return outOfRangeErrorMessage;
    if (!(customerAddressDict.zip in servicableZipcodes))
        return outOfRangeErrorMessage;
    return "";
}
export function getSubscriptionOrderStatus(order, isChefSide) {
    // scheduled: default status
    // upcoming: <100 hours until order is charged
    // ready: order has been charged
    // complete: order has been fulfilled
    // skipped: order has been skipped (making it only visibile when looking at orders in a subscription)
    // alert: order has been skipped and is now ready
    if (!order ||
        !order.timeSlot ||
        !order.timeSlot.startTime ||
        !order.timeSlot.endTime)
        return "alert";
    const currTime = new Date().getTime();
    const orderTimestamp = order.timeSlot.startTime;
    const chargeTimestamp = order.chargeTimestamp;
    if (isChefSide) {
        if (order.skipped) {
            return "skipped";
        }
        else {
            return "scheduled";
        }
    }
    // CHARGE 100 hours before fufillment
    if (currTime > order.timeSlot.endTime)
        return "complete";
    if (order.skipped)
        return "skipped";
    if (order.needsPaymentMethodUpdate) {
        if (currTime > orderTimestamp - 1000 * 60 * 60 * 24)
            return "skipped";
        return "alert";
    }
    if (orderTimestamp > currTime) {
        //assuming we charge 100 hours before fulfillment
        if (currTime > chargeTimestamp ||
            (typeof order.paymentIntentId === "string" &&
                order.paymentIntentId.includes("pi_")))
            return "ready";
        if (currTime + 1000 * 60 * 60 * 100 > chargeTimestamp)
            return "upcoming";
        return "scheduled";
    }
    return "complete";
}
export function getSubscriptionOrderAlertType(order) {
    return null;
}
export function getAdjustedTimeSlot(order) {
    if (!order)
        return {};
    const timeSlot = order.timeSlot;
    const cartType = order.cartType;
    return {
        startTime: timeSlot.startTime +
            (cartType === "delivery"
                ? timeSlot.startTimeDeliveryOffset
                    ? timeSlot.startTimeDeliveryOffset
                    : 0
                : 0),
        endTime: timeSlot.endTime +
            (cartType === "delivery"
                ? timeSlot.endTimeDeliveryOffset
                    ? timeSlot.endTimeDeliveryOffset
                    : 0
                : 0),
        range: timeSlot.range,
    };
}
export function emailIsValid(email) {
    if (!email || typeof email !== "string")
        return false;
    const emailPattern = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    return emailPattern.test(email);
}
export function promiseTimeout(ms, promise, passOnTimeout = false) {
    // Create a promise that rejects in <ms> milliseconds
    let timeout = new Promise((resolve, reject) => {
        let id = setTimeout(() => {
            clearTimeout(id);
            if (passOnTimeout)
                resolve("Timed out in " + ms + "ms.");
            else
                reject("Timed out, Try again.");
        }, ms);
    });
    // Returns a race between our timeout and the passed in promise
    return Promise.race([promise, timeout]);
}
export function getTestSubscriptionPhones() {
    return [
        "+12026579724",
        "+12026698810",
        "+12029052549",
        "+12063704542",
        "+12132745857",
        "+12134401400",
        "+12158214931",
        "+12245583450",
        "+12815366302",
        "+12819892259",
        "+13038805541",
        "+13104398751",
        "+13104835167",
        "+13105605498",
        "+13109930401",
        "+13124010145",
        "+13124511339",
        "+13135166354",
        "+13238559778",
        "+13476889743",
        "+13477485805",
        "+14049319282",
        "+14082509830",
        "+14087814597",
        "+14088385840",
        "+14122660511",
        "+14152039496",
        "+14152055026",
        "+14152153891",
        "+14152179676",
        "+14152356023",
        "+14152460647",
        "+14152546634",
        "+14152546717",
        "+14152649065",
        "+14152692968",
        "+14152798049",
        "+14152906809",
        "+14152971694",
        "+14153052549",
        "+14153057542",
        "+14153107818",
        "+14153163695",
        "+14153186560",
        "+14153689376",
        "+14153776440",
        "+14153786295",
        "+14153788129",
        "+14154209805",
        "+14154259479",
        "+14154759653",
        "+14155150927",
        "+14155185870",
        "+14155330583",
        "+14155591344",
        "+14155721892",
        "+14156010131",
        "+14156069628",
        "+14156082859",
        "+14156086905",
        "+14156249800",
        "+14156721368",
        "+14156848585",
        "+14156861084",
        "+14157131682",
        "+14157222520",
        "+14157288792",
        "+14157302905",
        "+14157947213",
        "+14157979431",
        "+14158238764",
        "+14158450646",
        "+14158476811",
        "+14158528650",
        "+14158675790",
        "+14158679622",
        "+14158859528",
        "+14158945092",
        "+14159099556",
        "+14159485184",
        "+14159487042",
        "+14159489662",
        "+14159878114",
        "+14159903195",
        "+14696826208",
        "+15102067334",
        "+15102908688",
        "+15103257145",
        "+15104686189",
        "+15104991513",
        "+15105209404",
        "+15106846157",
        "+15107895519",
        "+15108282142",
        "+15109173577",
        "+15705044178",
        "+15743159017",
        "+16032643124",
        "+16034796794",
        "+16126169892",
        "+16126189526",
        "+16128770387",
        "+16163189289",
        "+16172400054",
        "+16172836620",
        "+16173204028",
        "+16263840848",
        "+16412330122",
        "+16462064761",
        "+16462343094",
        "+16463193822",
        "+16466831034",
        "+16502792091",
        "+16502912037",
        "+16502967878",
        "+16503531655",
        "+16503917819",
        "+16504381677",
        "+16504600815",
        "+16504647406",
        "+16504684553",
        "+16505050733",
        "+16506869961",
        "+16507851112",
        "+16507855039",
        "+16507931352",
        "+16786622490",
        "+16788602909",
        "+17033072252",
        "+17089551932",
        "+17132402137",
        "+17328321802",
        "+17739368772",
        "+17742793968",
        "+17864234118",
        "+18044970533",
        "+18082829502",
        "+18186060861",
        "+18186342742",
        "+18479770373",
        "+18579190415",
        "+18584426873",
        "+18642382767",
        "+19032418776",
        "+19143936564",
        "+19144509546",
        "+19172513986",
        "+19173282828",
        "+19173558118",
        "+19173613461",
        "+19176030492",
        "+19259174598",
        "+19259180280",
        "+19492301891",
        "+19496833458",
        "+19729777432",
        "+19732240269",
        "+19737157276",
    ];
}
/**
 * Simple mutation builder similar to useMutation from react-query.
 * @param {string} stateKey Key within `this.state` in which state
 * for the mutation will be stored. MUST BE TOP LEVEL!
 * @param {Function} mutationFn MUST RETURN A PROMISE!
 * @param {Object} options
 * @returns Useful stuff, duh. Remember to bind the mutate/mutateAsync functions.
 */
export function createClassMutation(stateKey, mutationFn, options) {
    var _a;
    const retry = (_a = options === null || options === void 0 ? void 0 : options.retry) !== null && _a !== void 0 ? _a : 0;
    const initialState = {
        data: undefined,
        error: undefined,
        isError: false,
        isIdle: true,
        isLoading: false,
        isSuccess: false,
        status: "idle",
    };
    /**
     * @param {object} variables An object that will be passed to your mutationFn
     */
    function mutate(variables) {
        mutateAsync(variables);
    }
    /**
     * @param {object} variables An object that will be passed to your mutationFn
     */
    function mutateAsync(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({
                [stateKey]: Object.assign(Object.assign({}, this.state[stateKey]), { error: undefined, isError: false, isIdle: false, isLoading: true, isSuccess: false, status: "loading" }),
            });
            for (let i = 0; i < 1 + retry; i++) {
                try {
                    const result = yield mutationFn(variables);
                    this.setState({
                        [stateKey]: Object.assign(Object.assign({}, this.state[stateKey]), { data: result, error: undefined, isError: false, isIdle: false, isLoading: false, isSuccess: true, status: "success" }),
                    });
                    return result;
                }
                catch (e) {
                    if (i === retry) {
                        this.setState({
                            [stateKey]: Object.assign(Object.assign({}, this.state[stateKey]), { error: e, isError: true, isIdle: false, isLoading: false, isSuccess: false, status: "error" }),
                        });
                        throw e;
                    }
                    yield sleep(Math.random() * 2000 + Math.min(15000, Math.pow(2, i) * 1000));
                }
            }
        });
    }
    function reset() {
        this.setState({
            [stateKey]: Object.assign(Object.assign({}, this.state[stateKey]), initialState),
        });
    }
    return {
        initialState,
        mutate,
        mutateAsync,
        reset,
    };
}
export function createOrder(cart, cartEvent, siteSettings, { firstName, lastName, fullName, phone, email, tip, customerAddressDict, // TODO KEANE should be in cart
customerDeliveryInstructions, // TODO KEANE should be in cart
deliveryFee, // TODO KEANE should be in cart
orderPlaced, // TODO KEANE doesn't belong
customFieldValues, eventRemindersEnabled, source, orderId, isHidden, }) {
    var _a;
    const order = {
        cartId: cart.id,
        orderId: orderId,
        source: source ? source : "",
        isHidden: isHidden ? isHidden : false,
        paymentIntentId: cart.paymentIntentId,
        cartType: cart.fulfillmentType,
        cartItems: cart.cartItems,
        chefId: cart.chefId,
        eventId: cart.eventId,
        timeSlot: cart.timeSlot,
        location: cart.location,
        discountCode: cart.discountCode ? cart.discountCode : null,
        giftCard: cart.giftCard ? cart.giftCard : null,
        customFields: (_a = cartEvent.customFields) === null || _a === void 0 ? void 0 : _a.map((customField, index) => ({
            title: customField.title,
            value: customFieldValues[index],
        })),
        ticketed: cartEvent.ticketed,
        siteSettings: siteSettings,
        firstName: firstName,
        lastName: lastName,
        fullName: firstName + " " + lastName,
        phone: phone,
        email: email,
        tip: tip,
        customerAddressDict: customerAddressDict,
        customerDeliveryInstructions: customerDeliveryInstructions,
        deliveryFee: deliveryFee,
        orderPlaced: orderPlaced,
        eventRemindersEnabled: eventRemindersEnabled,
    };
    order["discountedValue"] = getOrderDiscount(order); // TODO: this is currently read by the Python backend, instead the backend should recalculate it
    order["amount"] = Math.round(parseFloat(getOrderTotal(order)) * 100); // used by updatePaymentIntent, may be vestigial now
    order["customerPaymentProcessingFee"] =
        getCustomerPaymentProcessingFee(order);
    return order;
}
export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
//# sourceMappingURL=helperFunctions.js.map